/* eslint-disable */
// @ts-nocheck

import { useController, UseControllerProps } from 'react-hook-form'

import { RadioGroup } from '@headlessui/react'

interface BasicCustomRadioDataInterface {
  id: string | number
}

interface CustomRadioInterface<T extends BasicCustomRadioDataInterface> {
  data: T[]
  action?: (value: string | number) => void
  className?: string
  itemComponent: (item: T, checked: boolean) => React.ReactNode
  endElement?: (item: T) => React.ReactNode
}

function classNames(...classes: string[]) {
  return classes.filter(Boolean).join(' ')
}

export default function GenericCustomRadio<
  T extends BasicCustomRadioDataInterface,
>(props: UseControllerProps & CustomRadioInterface<T>) {
  const { data, action, className, itemComponent, endElement } = props
  const { field } = useController(props)

  const onChange = (value: string | number) => {
    field.onChange(value)
    if (action) action(value) // Call the action only if it exists
  }

  return (
    <div className="p-2">
      <RadioGroup onChange={onChange} value={field.value}>
        <div className="flex flex-col space-y-4">
          {data?.map((item) => (
            <div className="flex gap-x-2" key={item.id}>
              <RadioGroup.Option
                className={({ checked, active }) =>
                  classNames(
                    checked ? 'border-2 border-slate-600' : 'border-gray-300',
                    active ? 'border-slate-600 ring-2 ring-slate-600' : '',
                    'flex cursor-pointer flex-col rounded-lg border bg-white px-6 py-4 text-sm shadow-sm focus:outline-none',
                    className ?? ''
                  )
                }
                value={item.id}
              >
                {({ checked }) => <>{itemComponent(item, checked)}</>}
              </RadioGroup.Option>

              {endElement && (
                <div className="flex flex-shrink items-center justify-center">
                  {endElement(item)}
                </div>
              )}
            </div>
          ))}
        </div>
      </RadioGroup>
    </div>
  )
}
